import React from 'react';
import NavBar from '../components/NavBar';


export default function Support() {
  return (
    <div>
      <NavBar />
      <h1>Support</h1>
    </div>
  );
}
